// extracted by mini-css-extract-plugin
export default {"Auth":"Auth_Auth__6NP4A","Logo":"Auth_Logo__H7X09","Title":"Auth_Title__CHO3q","Error":"Auth_Error__OlUzr"};